import { Injectable } from '@angular/core';
import { ApiBase } from '@apis/cas';
import { Observable } from 'rxjs';
import { StructType, StructTypeUpdate } from '@apis/cas/generated';

@Injectable({ providedIn: 'root' })
export class StructTypeEndpoints extends ApiBase {
  public getAllStructTypes(): Observable<StructType[]> {
    return this.get<StructType[]>(`/game/${this.gameId}/schema/struct-types`);
  }

  public getStructType(structTypeId: string): Observable<StructType> {
    return this.get<StructType>(`/game/${this.gameId}/schema/struct-types/${structTypeId}`);
  }

  public createStructType(structType: StructType): Observable<StructType> {
    return this.post<StructType>(`/game/${this.gameId}/schema/struct-types`, structType);
  }

  public updateStructType(updateStructType: StructTypeUpdate, force = false): Observable<StructType> {
    return this.put<StructType>(`/game/${this.gameId}/schema/struct-types/${updateStructType.typeId}`, updateStructType, {
      params: force ? { force: 'true' } : undefined,
    });
  }

  public deleteStructType(structTypeId: string, force = false): Observable<void> {
    return this.delete<void>(`/game/${this.gameId}/schema/struct-types/${structTypeId}`, {
      params: force ? { force: 'true' } : undefined,
    });
  }
}
